module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/santaanalane.adad649.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/santaanalane.jpg
// module id = g/+8
// module chunks = 0